import { tsParticles } from 'tsparticles-engine';
import { loadFull } from 'tsparticles';
import { v4 } from 'uuid';

import { PARTICLES_CONTAINER_ID_PREFIX } from './particles.consts';
import { ParticleContainer, ParticleOptions } from './particles.types';

export const initializeTSParticles = async (
  htmlID: string,
  options: ParticleOptions
): Promise<ParticleContainer> => {
  // @INFO consider loading only specific plugins, that are required by our configs
  await loadFull(tsParticles);
  const container = await tsParticles.load(htmlID, options);

  return container as ParticleContainer;
};

export const createHtmlID = (prefix = PARTICLES_CONTAINER_ID_PREFIX) => `${prefix}-${v4()}`;
